import React, { useState, useEffect } from 'react';
import { Box, Container } from '@material-ui/core';
import { useSnackbar } from 'notistack';

import Page from '../../../components/Layout/Page';
import Header from './Header';
import Results from './Results';
import { getSupermarketsWithScrapeInfo } from '../../../requests/api/supermarkets';
import useStyles from './styles';

function SupermarketsListView() {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [supermarkets, setSupermarkets] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSupermarkets = async () => {
      try {
        const response = await getSupermarketsWithScrapeInfo();
        if (response.success && response.data?.data) {
          const data = Array.isArray(response.data.data)
            ? response.data.data
            : response.data.data?.supermarkets || [];
          setSupermarkets(data);
        } else {
          enqueueSnackbar('Error al cargar el listado de supermercados.', {
            variant: 'error',
          });
        }
      } catch {
        setSupermarkets([]);
        enqueueSnackbar('Error al cargar el listado de supermercados.', {
          variant: 'error',
        });
      } finally {
        setLoading(false);
      }
    };
    fetchSupermarkets();
  }, [enqueueSnackbar]);

  return (
    <Page
      className={classes.root}
      title="FH Engel | Supermercados"
    >
      <Container maxWidth={false}>
        <Header />
        <Box mt={3}>
          <Results supermarkets={supermarkets} loading={loading} />
        </Box>
      </Container>
    </Page>
  );
}

export default SupermarketsListView;
